/**
 * Platform-safe haptic feedback utilities.
 *
 * expo-haptics is a no-op / throws on web. Instead of guarding every call
 * site with `Platform.OS !== 'web'`, import from here and call freely on
 * all platforms. The guard is centralised in one place.
 */
import { Platform } from 'react-native'
import * as Haptics from 'expo-haptics'

const isNative = Platform.OS !== 'web'

/** Light / medium / heavy impact feedback. */
export function impact(style: Haptics.ImpactFeedbackStyle = Haptics.ImpactFeedbackStyle.Medium) {
  if (isNative) void Haptics.impactAsync(style)
}

/** Success / warning / error notification feedback. */
export function notification(type: Haptics.NotificationFeedbackType) {
  if (isNative) void Haptics.notificationAsync(type)
}

/** Selection change tick (e.g. picker scroll, toggle). */
export function selection() {
  if (isNative) void Haptics.selectionAsync()
}

// Re-export enums for convenience so callers don't need a second import.
export const ImpactStyle = Haptics.ImpactFeedbackStyle
export const NotificationType = Haptics.NotificationFeedbackType
